import { usePaymentMethods } from "../../../checkout/hooks";

export function FooterPaymentMethods() {
  const { paymentMethodsList } = usePaymentMethods();

  return (
    <div className="flex items-center gap-3 rtl:gap-3">
      {paymentMethodsList.map((method) => (
        <img
          key={method.method}
          src={method.image}
          alt={method.name}
          title={method.name}
          className="h-6 transition-transform duration-300 hover:scale-105"
        />
      ))}
    </div>
  );
}
